import { transformFilterStackToGelly } from "./transformFilterStackToGelly"
import { transformFilterStackToGraphQLFilter } from "./transformFilterStackToGraphQLFilter"
import { transformGraphQLFilterToGelly } from "./transformGraphQLFilterToGelly"
import { transformSortArrayToGraphQLSortOrder } from "./transformSortArrayToGraphQLSortOrder"

window.Authentified = {
  transformFilterStackToGelly,
  transformFilterStackToGraphQLFilter,
  transformGraphQLFilterToGelly,
  transformSortArrayToGraphQLSortOrder,
}

declare global {
  interface Window {
    Authentified: {
      transformFilterStackToGelly: typeof transformFilterStackToGelly
      transformFilterStackToGraphQLFilter: typeof transformFilterStackToGraphQLFilter
      transformGraphQLFilterToGelly: typeof transformGraphQLFilterToGelly
      transformSortArrayToGraphQLSortOrder: typeof transformSortArrayToGraphQLSortOrder
    }
  }
}

export {
  transformFilterStackToGelly,
  transformFilterStackToGraphQLFilter,
  transformGraphQLFilterToGelly,
  transformSortArrayToGraphQLSortOrder,
}
